module.exports = __webpack_public_path__ + "static/media/turigye.802dbcc1.png";